import { makeStyles } from '@material-ui/core'
import { createStyles } from '@material-ui/core/styles'

const getAvatarBackground = (word: string | undefined) => {
  const words = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ']
  const backgrounds = ['#037EF3', '#00C16E', '#0CB9C1', '#F48924', '#9E44D6', '#52565E']
  const wordBackgroundIndex = words.findIndex((value) => value === word) % 6
  const notfound = wordBackgroundIndex === -1

  return notfound ? backgrounds[3] : backgrounds[wordBackgroundIndex]
}

const useStyles = makeStyles((theme) =>
  createStyles({
    accountDropDown: {
      display: 'flex',
      marginRight: '20px',
    },
    paper: {},
    root: {
      display: 'flex',
      marginRight: '20px',
    },
    button: {
      // height: '24px',
      display: 'flex',
      padding: 0,
      textTransform: 'none',
      marginTop: '10px',
      '&:hover': {
        // backgroundColor: '#fff',
        backgroundColor: 'transparent',
      },
    },
    account: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      marginTop: '20px',
      marginBottom: '30px',
    },
    accountText: {
      fontSize: '12px',
      lineHeight: '17px',
      fontWeight: 500,
      color: theme.variables.deepBlue,
    },
    avatar: ({ word }: { word: string | undefined }) => ({
      fontSize: '16px',
      lineHeight: '24px',
      borderRadius: '50%',
      marginRight: '8px',
      width: '35px',
      height: '35px',
      backgroundColor: getAvatarBackground(word),
      color: '#fff',
      fontWeight: 400,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }),
    name: {
      marginTop: '10px',
      fontFamily: 'Noto Sans TC',
      fontStyle: 'normal',
      fontWeight: 400,
      marginRight: '8px',
      fontSize: '16px',
      lineHeight: '22px',
      textAlign: 'center',
      color: '#202833',
    },
    arrowDown: {
      width: '12px',
      height: '12px',
      '& > g > path': {
        fill: '#BED1F6',
      },
    },
    tabletAndMobileStyle: {
      [theme.breakpoints.down('md')]: {
        width: '350px',
        height: '320px',
      },
      [theme.breakpoints.down(376)]: {
        width: '350px',
        height: '350px',
      },
    },
    itemSmallView: {
      display: 'flex',
      gap: '15px',
      '&.MuiMenuItem-root': {
        borderBottom: '1px solid lightgray',
        padding: '10px 0',
        margin: '0 20px',
      },
    },
    itemSmallViewLast: {
      display: 'flex',
      gap: '15px',
      padding: '10px 0',
      margin: '0 20px',
      borderBottom: 'none',
    },
  }),
)

export default useStyles
